import { initialColumnConfigs } from './reportColumns'
import { initialMetricConfigs } from './metrics'
import { initialFilterConfigs } from './filters'
import { initialChartConfigs } from './charts'

/** Top N options for grouped trends (e.g. Breakdown by Account). Used in report config and GroupedTrendsChart. */
export const trendTopNOptions = [
  { key: 25, label: 'Top 25' },
  { key: 50, label: 'Top 50' },
]
/** Default Top N when not set or when stored value is not in trendTopNOptions. */
export const trendTopNDefault = trendTopNOptions[0]?.key ?? 25

/** Time period options for trend grouping (day/week/month/quarter/year). Used in report config and GroupedTrendsChart. */
export const trendTimePeriodOptions = [
  { key: 'day', label: 'Day' },
  { key: 'week', label: 'Week' },
  { key: 'month', label: 'Month' },
  { key: 'quarter', label: 'Quarter' },
  { key: 'year', label: 'Year' },
]

/** Chart type options for grouped trends. Used in report config and GroupedTrendsChart. */
export const trendChartTypeOptions = [
  { key: 'stacked', label: 'Stacked Bar', description: 'Compare totals by day' },
  { key: 'grouped', label: 'Grouped Bar', description: 'Compare within each day' },
  { key: 'line', label: 'Line Chart', description: 'Show trends over time' },
  { key: 'heatmap', label: 'Heatmap', description: 'Find patterns across time' },
]

export const defaultDashboardConfig = {
  columns: initialColumnConfigs,
  metrics: initialMetricConfigs,
  filters: initialFilterConfigs,
  charts: initialChartConfigs,
}

export { initialChartConfigs, updateConfigChartType } from './charts'
export { filterConfigs, allFilterFormatters, filterArrangement, initialFilterConfigs } from './filters'
export { initialMetricConfigs, metricConfigNames } from './metrics'
export { initialSortOrders, proCustReportKeys, reportKeys, initialColumnConfigs, updateConfigSortOrder, reportDefaultInvisibleColumns } from './reportColumns'
